import {Component, OnInit, AfterViewInit, Output, EventEmitter} from '@angular/core';
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-activity-form',
  templateUrl: './activity-form.component.html',
  styleUrls: ['./activity-form.component.css',]
})
export class ActivityFormComponent implements OnInit , AfterViewInit {
    personalUserSelected: boolean;
    options:any;
    scaleOptions:any;
    postOptions:any;
    isScaleClicked: boolean;
    land: boolean;
    shenqing: boolean;
    scrollTop:number;
    choiceBtnDisable: boolean;
    showButton: boolean;
    choiceBtnText: string;
    registerType: number;
    phone: string;
    verification_code: string;
    phone_1: string;
    phone_2: string;
    verification_code_1: string;
    verification_code_2: string;
    name: string;
    size: string;
    title: string;
    myname: string;
    isKeybordShow: boolean;
    formId: number;
    status: any;
    oriHeight: number;
    canSendCode: boolean;
    submitButtonDisabled: boolean;
    content: boolean;
    yishengqing: boolean;
    tijiao: boolean;
    registerCode:string;
  formIdTag:boolean;
  _signInNumber:boolean = false;
  _signInPhone:boolean=true;
	
submitButtonDisabledNum: boolean=true;
submitButtonDisabledPhone: boolean=true;
	//账号密码
    Number: string;
	Number_1:string;
    verification_pwd: string;
	verification_Pwd_1:string;

    @Output() onSuccess = new EventEmitter<boolean>();

    constructor(private apiService: ApiService,
      private route: ActivatedRoute,
      private router: Router,
      private commonService: CommonService,
    ) { }

    ngOnInit() {
      this.getStatus();
      this.status = this.route.params.subscribe(params => {
        this.formId = params['formId'];
        this.registerCode = params['codeId'];
        if(this.formId==299 || this.formId==399||this.formId==398||this.formId>=600){
          this.formIdTag = true;
        }else{
          this.formIdTag = false;
        }
      });

      if (this.formId == 3 || this.formId==398) {
        this.shenqing = true;
        this.land = false;

      }
      if (this.formId == 1 || this.formId == 299 || this.formId==399||this.formId>=600)  {
        this.land = true;
        this.shenqing = false;

      }
      this.registerType = 2;
      this.canSendCode = true;
      this.submitButtonDisabled = false;
      this.personalUserSelected = false;
      this.scaleOptions=[
          "1-50人",
          "51-300人",
          "301-1000人",
          "1000人以上"
      ];
      this.postOptions=[
          "公司高层",
          "HR部门",
          "中基层企业管理者",
          "其他"
      ];
      this.options = this.scaleOptions;
      this.isKeybordShow = false;
      let that = this;
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
          isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if(isAndroid){
          $(window).resize(function () {
              let newHeight = $(window).height();
              if (that.oriHeight-newHeight>100){
                that.isKeybordShow = true;
              } else if (that.oriHeight==newHeight){
                that.isKeybordShow = false;
              }
          });
      }

      // if(isIOS){
      //   $(window).resize(function () {
      //     let newHeight = $(window).height();
      //     if (that.oriHeight-newHeight>100){
      //       that.isKeybordShow = true;
      //     } else if (that.oriHeight==newHeight){
      //       that.isKeybordShow = false;
      //     }
      //   });
      // }

      this.showButton = false;

      let href  = window.location.href;
      let str = href.split('/form/')[1];
      if(str!='3#wechat_login' && str!='3'){
        window.sessionStorage.setItem('specialUser','specialUser');
      }else{
        window.sessionStorage.removeItem('specialUser');
      }
  }

    ngAfterViewInit(){
		this.commonService.initPage();

        let choiceBox=document.getElementById("choice");
        let choiceBoxHeight=choiceBox.offsetHeight;
        let bodyHeight=document.body.offsetHeight;
        choiceBox.style.top=bodyHeight + 'px';
        choiceBox.style.maxHeight=document.body.offsetHeight*0.99 + 'px';

        this.oriHeight = $(window).height();
    }
    getStatus() {
      this.apiService.ajax({
        'type': 'post',
        'url': '/api/getUserInfo',
        'data': {}
      }).subscribe(status => {
        this.status = status;
        if (this.status != 3) {
          this.yishengqing = true;
          this.tijiao = false;
        }
        else {
          this.yishengqing = false;
          this.tijiao = true;
        }

      });
    }
    shiyong() {
      $("#mengban").fadeOut();
      $("#tab_3").fadeOut();
      this.shenqing = true;
    }
    closeTip() {
      $("#mengban").fadeOut();
    }

    close(){
      let newEdition = window.sessionStorage.getItem('newEdition');
      if(newEdition){
        let link = ['activity'];
        this.router.navigate(link);
      }else{
        let link = ['learning-map'];
        this.router.navigate(link);
      }
    }

    tabTitleClicked(bool:boolean){
        this.personalUserSelected = bool;
        this.registerType = bool ? 1 : 2;
        if(!this.canSendCode){
            $("#tab_1_verification_send_out").css({"color":"#ffe258"});
            $("#tab_2_verification_send_out").css({"color":"#ffe258"});
        }
    }

    onScaleClicked(){
        $('.companySizeValidateTxt').removeClass('showValidateTxt');
        if(!this.isKeybordShow){
            this.options = this.scaleOptions;
            this.isScaleClicked = true;
            this.display();
        }
    }

    onPostClicked(){
      $('.companyJobValidateTxt').removeClass('showValidateTxt');
        if(!this.isKeybordShow){
            this.options = this.postOptions;
            this.isScaleClicked = false;
            this.display();
        }
    }

    onChoiceClick(option){
        this.hide();
        if(this.isScaleClicked){
            $("#tab_2_scale_input").val(option);
            this.size = option;
        }else{
            $("#tab_2_post_input").val(option);
            this.title = option;
        }
    }

    onShadeClick(){
        this.hide();
    }

    onFocus(id){
        let _this = this;
        let target = $("#"+id).data('target');
        console.log(target);
        $('.'+target+'ValidateTxt').removeClass('showValidateTxt');
        $("#"+id).bind('input porpertychange',function(){
            if(_this.checkMobile($("#"+id).val())){
                if(_this.personalUserSelected){
                    $("#tab_1_verification_send_out").css({"color":"#fff"});
                }else{
                    $("#tab_2_verification_send_out").css({"color":"#fff"});
                }
            }else{
                if(_this.canSendCode){
                    if(_this.personalUserSelected){
                        $("#tab_1_verification_send_out").css({"color":"#a4a9c0"});
                    }else{
                        $("#tab_2_verification_send_out").css({"color":"#a4a9c0"});
                    }
                }
            }
        });
    }

    onBlur(){
        console.log("#tab_2_company_input ---- blur");
    }

    display(){
        let choiceBox=document.getElementById("choice");
        choiceBox.style.display="block";
        let choiceBoxHeight=choiceBox.offsetHeight;
        let bodyHeight=document.body.offsetHeight;
        choiceBox.style.top=bodyHeight-choiceBoxHeight+'px';
        $("#shade").fadeIn(500);

        /*this.scrollTop = document.body.scrollTop | document.documentElement.scrollTop;
        $("#wrap").addClass("fixed");
        $("#wrap").css({top:-this.scrollTop});*/

        document.getElementById('shade').ontouchmove = function(e){ e.preventDefault(); }
        document.getElementById('choice').ontouchmove = function(e){ e.preventDefault(); }
    }

    hide(){
        let choiceBox=document.getElementById("choice");
        let bodyHeight=document.body.offsetHeight;
        choiceBox.style.top=bodyHeight+'px';
        setTimeout(function () {
            choiceBox.style.display="none";
        },500);
        $("#shade").fadeOut(500);

        /*$("#wrap").removeClass("fixed");
        document.documentElement.scrollTop = this.scrollTop;*/
    }

    checkMobile(mobile){
        if((!(/^1[3|4|5|6|7|8|9]\d{9}$/.test(mobile))) && ((mobile.indexOf("886")!=0 ) && (mobile.indexOf("852")!=0 )) ){
            return false;
        }
        return true;
    }

    tip(tipWord:string){
        /*document.getElementById("tip").style.display="none";*/
        $("#tip").text(tipWord);
        $("#tip").fadeIn(2000,function () {
            $("#tip").fadeOut(2000);
        });
    }

    sendCode(isPersonal:boolean) {
        if(isPersonal&&this.canSendCode){
            this.phone = this.phone_1;
        }else if(!isPersonal&&this.canSendCode){
            this.phone = this.phone_2;
        }
        if (!this.canSendCode) {
            // this.tip("请等待倒计时结束再发送");
          $('.smsCodeValidateTxt').text('请等待倒计时结束再发送');
          $('.smsCodeValidateTxt').addClass('showValidateTxt');
            return;
        }

        if (this.phone == "" || typeof(this.phone) == 'undefined') {
            // this.tip("请填写手机号");
          $('.phoneValidateTxt').text('请填写手机号');
          $('.phoneValidateTxt').addClass('showValidateTxt');
            return;
        }

        if (!this.checkMobile(this.phone)) {
          $('.phoneValidateTxt').text('请填写正确手机号');
          $('.phoneValidateTxt').addClass('showValidateTxt');
            // this.tip("请填写正确手机号");
            return;
        }

        this.canSendCode = false;

        var remainTime = 60;
        var that = this;
        var timeInterval = setInterval(function () {
            if(isPersonal){
                $("#tab_1_verification_send_out").css({"color":"#ffe258"});
                $("#tab_1_verification_send_out_word").text("重新获取");
                $("#tab_1_verification_send_out_remain_time").text("(" + remainTime + "s)");
            }else{
                $("#tab_2_verification_send_out").css({"color":"#ffe258"});
                $("#tab_2_verification_send_out_word").text("重新获取");
                $("#tab_2_verification_send_out_remain_time").text("(" + remainTime + "s)");
            }
            /*$(".send_out_word").text("重新获取");
            $(".remainTime").each(function( index ) {
                $(this).text("(" + remainTime + "s)");
            });*/
            remainTime = remainTime - 1;

            if (remainTime == -1) {
                $(".remainTime").each(function( index ) {
                    $(this).text("");
                });
                clearInterval(timeInterval);
                that.canSendCode = true;
                $(".send_out").css({"color":"#a4a9c0"});
                $(".send_out_word").text("发送验证码");
            }
        }, 1000);

        var data = {
            "phone": this.phone
        };

        this.apiService.sendCode(data).subscribe(result => {

            if (result.Code != "OK") {
                if(result.Code = "isv.BUSINESS_LIMIT_CONTROL"){
                   this.tip("操作频繁，请稍后尝试");
                }else{
                    //this.tip(result.Message);
                    this.tip("有错误，请重新操作");
                }
            }
        });
    }
	///* 企业员工可以通过员工号密码登录学习  2019-9-4 start*/
	// $("input").blur(function () {
	//    $("#tab_4").animate({scrollTop: document.documentElement.clientHeight},500);
	// });
	click_blur(){
		// $("#tab_4").animate({scrollTop: document.documentElement.clientHeight},500);
		window.scroll(0, 0);
		this.commonService.initPage();
		console.log(11);
	}
	signInPhone(){//账号登录切换
		// $('.signInPhone').css('display','none');
		// $('.signInNumber').css('display','block');
		this._signInNumber = true;
		this._signInPhone = false;
		$('#tab_1_Phone_input').val("");
		$('#tab_1_verification_input').val("");
		this.phone_1 = "";
		this.verification_code_1 = "";
		// this.Number = '';
		// this.verification_pwd='';
	 //    this.phone = '';
		// this.verification_code='';
	}
	signInNumber(){//手机号码登录切换
		// $('.signInPhone').css('display','block');
		// $('.signInNumber').css('display','none');
		this._signInNumber = false;
		this._signInPhone = true;

		$('#tab_1_Number_input').val("");
		$('#tab_1_Pwd_input').val("");
		this.Number_1 = '';
		this.verification_Pwd_1='';
	 //    this.phone = '';
		// this.verification_code='';
	}
	toset(msg){
		$("#toset_div").empty();
		$("#toset_div").css("display","block");
		$("#toset_div").append(msg);
		setTimeout("$('#toset_div').hide()",1500);
		
	}
	loginPhone(){////手机号码登录
      this.phone = this.phone_1;
      this.verification_code = this.verification_code_1;
      if (this.phone == "" || typeof (this.phone) == 'undefined') {
        // this.tip("请填写手机号");
        // $('.phoneValidateTxt').text('请填写手机号码');
        // $('.phoneValidateTxt').addClass('showTxt');
		this.toset("请填写手机号");
        return false;
      }

      if (!this.checkMobile(this.phone)) {
        // $('.phoneValidateTxt').text('请填写正确手机号');
        // $('.phoneValidateTxt').addClass('showTxt');
        this.toset("该手机号码暂不支持");
        return false;
      }

      this.submitButtonDisabled = true;
      if (!this.phone) {
        this.toset("请填写手机号码");
        // $('.phoneValidateTxt').text('请填写手机号码');
        // $('.phoneValidateTxt').addClass('showTxt');
        this.submitButtonDisabled = false;
        return false;
      }
      else if (!this.verification_code) {
        this.toset("请填写手机验证码");
        // $('.smsCodeValidateTxt').text('请填写手机验证码');
        // $('.smsCodeValidateTxt').addClass('showTxt');
        this.submitButtonDisabled = false;
        return false;
      }
		
	var dataphone={
		"phone": this.phone,
		"verificationCode":this.verification_code,
	};			
    this.apiService.ajax({
      'type': 'post',
      'url': 'sr/userlogin/validateLogonPhone',
      'data': dataphone,
    }).subscribe(result=>{
      if(result.success){
				this.loginPhp();
								
			// }else if(result.data==2){//弹出提示框
			// 	$(".model_div").css('display','block');
			// 	$(".phoneClass").css('display','block');
			// }else{
			// 	this.tip("返回错误！");
			// }
		}else{
			if(result.code ==1000){
				this.toset("用户userId不存在");
				return;
			}else if(result.code ==1003){
				$(".model_div").css('display','block');
				$(".phoneClass").css('display','block');
			}else if(result.code ==2001){//phone
				this.toset("该手机号在系统中不存在");
				return;
			}else if(result.code ==2002){//phone
				this.toset("手机号或验证码不正确");
				return;
			}
		  }
		});	


	}
	
	loginPhp(){
      var data = {
        "registerType":1,
        "phone": this.phone,
        "verification_code": this.verification_code,
      };
			
      this.apiService.registerUser(data).subscribe(result => {
        console.log(result);
        if (result.code == "Success") {
          console.log("登陆成功");
					
						var dataphone={
							"phone": this.phone,
						};	
						 this.apiService.ajax({
							'type': 'post',
							'url': 'sr/userlogin/authenticationPhone',
							'data': dataphone,
						}).subscribe(result => {
							console.log(result);
							if (result.success == true) {//登录成功
								 console.log("登陆成功");
								 if(this.formId>=600){
										let link = ['learning-map',this.formId];
										this.router.navigate(link);
									}else{
										let link = ['learning-map'];
										this.router.navigate(link);
									}
							}else{//登录失败
									// $('.smsCodeValidateTxt').text('手机号或验证码不正确');
									// $('.smsCodeValidateTxt').addClass('showTxt');
									this.submitButtonDisabled = false;
									this.toset("手机号或验证码不正确");
									return;
							}
						});
						
        }
        if (result.code == "Not_Lookup_Company") {
          console.log("您还没有绑定任何账户");
		  this.toset("您还没有绑定任何账户");
          $("#mengban").fadeIn();
        }
        else if (result.code == "Not_Matched") {
          // this.tip("手机号或验证码不正确");
          // $('.smsCodeValidateTxt').text('手机号或验证码不正确');
          // $('.smsCodeValidateTxt').addClass('showTxt');
		  this.toset("手机号或验证码不正确");
          this.submitButtonDisabled = false;
          return;
        }
        else if (result.code == "Duplicate_Company") {
          // this.tip(this.name + "已经被注册");
          // $('.smsCodeValidateTxt').text(this.name + "已经被注册");
          // $('.smsCodeValidateTxt').addClass('showTxt');
		  this.toset(this.name + "已经被注册");
          this.submitButtonDisabled = false;
          return;
        }
        else if (result.code == "Phone_Not_Matched") {
          // this.tip("手机号和接受验证码手机号不一致，请重新发送验证码");
          // $('.smsCodeValidateTxt').text('手机号或验证码不正确');
          // $('.smsCodeValidateTxt').addClass('showTxt');
		  this.toset("手机号和接受验证码手机号不一致，请重新发送验证码");
          this.submitButtonDisabled = false;
          return;
        }
      });
	}

  loginAgainPhone(){//继续登录
    $(".model_div").css('display','none');
    $(".phoneClass").css('display','none');
		this.loginPhp();
  }
  	
	loginPwd(){//账号登录
			this.Number = this.Number_1;
      this.verification_pwd = this.verification_Pwd_1;
      if (this.Number == "" || typeof (this.Number) == 'undefined') {
        // this.tip("请填写账号");
        // $('.NumberValidateTxt').text('请填写账号');
        // $('.NumberValidateTxt').addClass('showTxt');
		this.toset("请填写账号");
        return false;
      }
      if (this.verification_pwd == "" || typeof (this.verification_pwd) == 'undefined') {
        // this.tip("请填写账号密码");
        // $('.PwdTxt').text('请填写账号密码');
        // $('.PwdTxt').addClass('showTxt');
		this.toset("请填写账号密码");
        return false;
      }
      var data = {
        "userName": this.Number,
        "password": this.verification_pwd,
      };

    this.apiService.ajax({
      'type': 'post',
      'url': 'sr/userlogin/validateLogon',
      'data': data,
    }).subscribe(result=>{
      if(result.success){
        this.apiService.ajax({
          'type': 'post',
          'url': 'sr/userlogin/authentication',
          'data': data,
        }).subscribe(result2=>{
          if(result2.success){
			 if(this.formId>=600){
					let link = ['learning-map',this.formId];
					this.router.navigate(link);
				}else{
					let link = ['learning-map'];
					this.router.navigate(link);
				}
          }
        });
      }else{
        // if(result.data==2){
        //   $(".model_div").css('display','block');
        //   $(".numberClass").css('display','block');
        // }else{
        //   // this.tip("账号密码不正确");
        //   // $(".signInform .input_text").css('border','1px solid #f96678');
        //   $('.PwdTxt').text('账号密码不正确');
        //   $('.PwdTxt').addClass('showTxt');
        //   this.submitButtonDisabled = false;
        //   return;
        // }
		if(result.code ==1000){
			this.toset("用户userId不存在");
			return;
		}else if(result.code ==1001){//number
			this.toset("该账号在系统中不存在");
			return;
		}else if(result.code ==1002){//number
			this.toset("账号或密码不正确");
			return;
		}else if(result.code ==1003){
          $(".model_div").css('display','block');
          $(".numberClass").css('display','block');
		}
		
      }
    })

	//  this.apiService.ajax({
	//   'type': 'post',
	//   'url': 'sr/userlogin/authentication',
	//   'data': data,
	// }).subscribe(result => {
	//   console.log(result);
	//   if (result.success == true) {//登录成功
     //      console.log("登陆成功");
     //      let link = ['learning-map'];
     //      this.router.navigate(link);
	//   }else{//登录失败
	// 	  if(result.data==2){
	// 		  console.log("您已在其他设备上登录，登录失败！");
	// 		  $(".model_div").css('display','block');
	// 		  $(".model_div_con").css('display','block');
	// 	  }else{
	// 		  // this.tip("账号密码不正确");
	// 		  // $(".signInform .input_text").css('border','1px solid #f96678');
	// 		  $('.PwdTxt').text('账号密码不正确');
	// 		  $('.PwdTxt').addClass('showTxt');
	// 		  this.submitButtonDisabled = false;
	// 		  return;
	// 	  }
    //
	//   }
    //
	// });
	}

	loginAgain(){
    $(".model_div").css('display','none');
    $(".numberClass").css('display','none');
    this.Number = this.Number_1;
    this.verification_pwd = this.verification_Pwd_1;
    var data = {
      "userName": this.Number,
      "password": this.verification_pwd,
    };

     this.apiService.ajax({
      'type': 'post',
      'url': 'sr/userlogin/authentication',
      'data': data,
    }).subscribe(result => {
      console.log(result);
      if (result.success == true) {//登录成功
         console.log("登陆成功");
         let link = ['learning-map'];
         this.router.navigate(link);
      }else{//登录失败
		  // $('.PwdTxt').text('账号密码不正确');
		  // $('.PwdTxt').addClass('showTxt');
		  this.submitButtonDisabled = false;
		  this.toset("账号密码不正确");
		  return;
      }
    });
  }

	cancel(){
	  $(".model_div").css('display','none');
	  $(".model_div_con").css('display','none');
	}
	///* 企业员工可以通过员工号密码登录学习  2019-9-4 end*/
    login() {
      this.phone = this.phone_1;
      this.verification_code = this.verification_code_1;
      if (this.phone == "" || typeof (this.phone) == 'undefined') {
        // this.tip("请填写手机号");
        $('.phoneValidateTxt').text('请填写手机号码');
        $('.phoneValidateTxt').addClass('showValidateTxt');
        return;
      }

      if (!this.checkMobile(this.phone)) {
        $('.phoneValidateTxt').text('请填写正确手机号');
        $('.phoneValidateTxt').addClass('showValidateTxt');
        // this.tip("请填写正确手机号");
        return;
      }

      this.submitButtonDisabled = true;
      if (!this.phone) {
        // this.tip("请填写手机号码");
        $('.phoneValidateTxt').text('请填写手机号码');
        $('.phoneValidateTxt').addClass('showValidateTxt');
        this.submitButtonDisabled = false;
        return false;
      }
      else if (!this.verification_code) {
        // this.tip("请填写手机验证码");
        $('.smsCodeValidateTxt').text('请填写手机验证码');
        $('.smsCodeValidateTxt').addClass('showValidateTxt');
        this.submitButtonDisabled = false;
        return false;
      }

      var data = {
        "registerType":1,
        "phone": this.phone,
        "verification_code": this.verification_code,
      };

      this.apiService.registerUser(data).subscribe(result => {
        console.log(result);
        if (result.code == "Success") {
          console.log("登陆成功");
          let link = ['learning-map'];
          this.router.navigate(link);
        }
        if (result.code == "Not_Lookup_Company") {
          console.log("您还没有绑定任何账户");
          $("#mengban").fadeIn();
        }
        else if (result.code == "Not_Matched") {
          // this.tip("手机号或验证码不正确");
          $('.smsCodeValidateTxt').text('手机号或验证码不正确');
          $('.smsCodeValidateTxt').addClass('showValidateTxt');
          this.submitButtonDisabled = false;
          return;
        }
        else if (result.code == "Duplicate_Company") {
          // this.tip(this.name + "已经被注册");
          $('.phoneValidateTxt').text(this.name + "已经被注册");
          $('.phoneValidateTxt').addClass('showValidateTxt');
          this.submitButtonDisabled = false;
          return;
        }
        else if (result.code == "Phone_Not_Matched") {
          // this.tip("手机号和接受验证码手机号不一致，请重新发送验证码");
          $('.phoneValidateTxt').text('手机号或验证码不正确');
          $('.phoneValidateTxt').addClass('showValidateTxt');
          this.submitButtonDisabled = false;
          return;
        }
      });
    }
    submitForm(isPersonal:boolean) {
        if(isPersonal){
            this.phone = this.phone_1;
            this.verification_code = this.verification_code_1;
        }else{
            this.phone = this.phone_2;
            this.verification_code = this.verification_code_2;
        }

        if (this.phone == "" || typeof(this.phone) == 'undefined') {
            // this.tip("请填写手机号");
          $('.phoneValidateTxt').text('请填写手机号');
          $('.phoneValidateTxt').addClass('showValidateTxt');
            return;
        }

        if (!this.checkMobile(this.phone)) {
            // this.tip("请填写正确手机号");
          $('.phoneValidateTxt').text('请填写正确手机号');
          $('.phoneValidateTxt').addClass('showValidateTxt');
            return;
        }

        this.submitButtonDisabled = true;
        if (this.registerType == 2) {
            if (!this.name) {
                // this.tip("请填写公司名称");
              $('.companyNameValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return false;
            }
            else if (!this.myname) {
              // this.tip("请填写姓名");
              $('.usernameValidateTxt').addClass('showValidateTxt');
              this.submitButtonDisabled = false;
              return false;
            }
            else if (!this.size) {
                // this.tip("请填写公司规模");
              $('.companySizeValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return false;
            }
            else if (!this.title) {
                // this.tip("请填写职务");
              $('.companyJobValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return false;
            }
        }

        if (!this.phone) {
            // this.tip("请填写手机号码");
          $('.phoneValidateTxt').text('请填写手机号码');
          $('.phoneValidateTxt').addClass('showValidateTxt');
            this.submitButtonDisabled = false;
            return false;
        } else if (!this.verification_code) {
            // this.tip("请填写手机验证码");
          $('.phoneValidateTxt').text('请填写手机验证码');
          $('.smsCodeValidateTxt').addClass('showValidateTxt');
            this.submitButtonDisabled = false;
            return false;
        }

        var data = {
            "registerType": this.registerType,
            "phone": this.phone,
            "verification_code": this.verification_code,
            "name": this.name,
            "size": this.size,
            "title": this.title,
            "myname": this.myname,
            "registerCode_2":this.registerCode
        };

        this.apiService.registerUser(data).subscribe(result => {
            console.log(typeof (result.code));
            if (result.code == "Success" || result.code == "1" || result.code == "2") {
              window.sessionStorage.setItem('submitType',result.code);
              let link = ['success'];
              this.router.navigate(link);
            }
            else if (result.code == "Not_Matched") {
                // this.tip("手机号或验证码不正确");
              $('.smsCodeValidateTxt').text('手机号或验证码不正确');
              $('.smsCodeValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Duplicate_Company") {
                // this.tip(this.name + "已经被注册");
              $('.phoneValidateTxt').text(this.name + "已经被注册");
              $('.phoneValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Phone_Not_Matched") {
                // this.tip("手机号和接受验证码手机号不一致，请重新发送验证码");
              $('.phoneValidateTxt').text('手机号和接受验证码手机号不一致,请重新发送验证码');
              $('.phoneValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Err_RegisterCode") {
                // this.tip("您的识别码有误/无效，请重新输入");
                $('.registerCodeValidateTxt').addClass('showValidateTxt');
                // let interval = setInterval(function () {
                //   $('.registerCodeValidateTxt').removeClass('showRegisterCodeValidateTxt');
                //   clearInterval(interval);
                // }, 2500);
                this.submitButtonDisabled = false;
                return;
            }

        });
    }
}



// WEBPACK FOOTER //
// ./src/app/activity-form/activity-form.component.ts